export default __webpack_public_path__ + "0c255d704c57d0a326143b7a435b77b5.png";